import { TemplateType } from '@server/trading-templates/schemas/input.schema';

// signalBlock is slot-scoped, so default behavior would be ambiguous.
export const canUseDefaultTemplate = (templateType: TemplateType) =>
  templateType !== 'signalBlock';
